export default "__VITE_ASSET__BkankfFl__"